import { Moment } from 'moment';

export class DocumentoAssinaturaVO {
  nome: string;
  dataCriacao: Moment;
  tipo: string;
  extensao: string;
  tamanho: number;
  arquivo: string;

}
